module.exports = __webpack_public_path__ + "static/media/InterviewX.08ab4110.png";